import { Button, Input, InputNumber } from "antd";
import { useEffect, useState } from "react";
import { getLimit, saveLimit } from "../service";
import { showToast } from "ui/components/common";

export default function Limits({ classes, orgId }) {
  const [limit, setLimit] = useState({});
  useEffect(() => {
    getLimit(orgId).then((data) => {
      if (data.status !== 200) {
        showToast(1, "Failed to fetch limit data");
        return;
      } else {
        setLimit(data.data);
      }
    });
  }, [orgId]);
  async function onSave() {
    const res = await saveLimit(limit, orgId);
    if (res.status !== 200) {
      showToast(1, "Failed to save limit data");
    } else {
      showToast(0, "Successfully saved");
    }
  }
  return (
    <div
      style={{
        flex: "none",
        height: "100%",
        width: "380px",
        borderRight: "1px solid rgba(225, 225, 225, 1)",
        padding: "24px",
      }}
    >
      {classes.map((item) => (
        <div
          style={{
            height: "132px",
            width: "332px",
            backgroundColor: "rgba(250, 250, 250, 1)",
            padding: "24px",
            borderRadius: "24px",
            marginBottom: "16px",
          }}
        >
          <div style={{ width: "100%" }}>
            <span style={{ fontWeight: "600", fontSize: "16px" }}>
              {item.label + " Daily Credit Limit"}
            </span>
            <span
              style={{
                fontWeight: "600",
                color: "rgba(113, 113, 113, 1)",
                float: "right",
              }}
            >
              Rec: {limit[item.value]?.rec ?? "-"}
            </span>
          </div>
          <Input
            style={{
              height: "54px",
              borderRadius: "16px",
              marginTop: "12px",
              width: "100%",
            }}
            onChange={(e) => {
              const value = e.target.value;
              if (isNaN(Number(value))) return;
              setLimit((prev) => ({
                ...prev,
                [item.value]: {
                  ...prev[item.value],
                  credit: value,
                },
              }));
            }}
            value={
              isNaN(Number(limit[item.value]?.credit))
                ? ""
                : limit[item.value]?.credit
            }
            placeholder="Enter daily limit"
          />
        </div>
      ))}
      <div className="min-h-[60px]">
        <Button
          className="primaryButton"
          style={{ float: "right" }}
          onClick={onSave}
        >
          Save
        </Button>
      </div>
    </div>
  );
}
